import { orchestrator } from 'satcheljs';
import removeFavoriteGroup from '../actions/v2/removeFavoriteGroup';
import deleteOutlookFavoriteService from '../services/v2/deleteOutlookFavoriteService';
import getFavoriteDataFromFavoriteId from '../selectors/v2/getFavoriteDataFromFavoriteId';
import {
    removeFavoriteFromStore,
    removeFavoriteCompleted,
    removeFavoriteFailed,
} from '../actions/v2/removeFavoriteActions';
import isGuid from '../utils/isGuid';
import getFavoriteIdFromGroupId from '../actions/v2/helpers/getFavoriteIdFromGroupId';
import { logUsage } from 'owa-analytics-actions';
import isOutlookFavoritingInProgress from '../selectors/v2/isOutlookFavoritingInProgress';
import favoritesStore from '../store/store';
import { FolderForestNodeType, FavoriteGroupData } from 'owa-favorites-types';

export default orchestrator(removeFavoriteGroup, async actionMessage => {
    const groupIdToRemove = actionMessage.groupIdToRemove;

    const favoriteId = getFavoriteIdFromGroupId(groupIdToRemove);
    const favoriteGroupData = getFavoriteDataFromFavoriteId(
        favoriteId,
        FolderForestNodeType.Group
    ) as FavoriteGroupData;

    // Check wheter we are trying to remove a temp id due to double clicks. This should be a no-op.
    if (isGuid(favoriteId)) {
        logUsage('RemoveOutlookFavoriteCategory: attempting to remove guid', { guid: favoriteId });
        return;
    }

    if (isOutlookFavoritingInProgress(favoriteGroupData.groupId)) {
        // No-op
        return;
    }

    // Check if outlookFavoriteGroups doesn't contain the id
    if (!favoritesStore.outlookFavoriteGroups.has(favoriteId)) {
        // No op
        return;
    }

    removeFavoriteFromStore(favoriteGroupData);

    // Use Favorite Roaming API to remove an outlook favorite
    deleteOutlookFavoriteService(favoriteId)
        .then(() => {
            removeFavoriteCompleted(favoriteGroupData);
        })
        .catch(error => {
            removeFavoriteFailed(error, favoriteGroupData);
        });
});
